import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import api from "../../axiosConfig";

export default function AgentEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({ name: "" });

  useEffect(() => {
    let alive = true;
    api.get(`/agent/${id}`)
      .then((res) => {
        if (!alive) return;
        const d = res.data || {};
        setForm((f) => ({ ...f, name: d.name ?? "" }));
        setLoading(false);
      })
      .catch((err) => {
        alert("Eroare la încărcare: " + (err.response?.data?.detail || err.message));
        setLoading(false);
      });
    return () => { alive = false; };
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setForm((f) => ({ ...f, [name]: checked }));
    } else if (type === "number") {
      setForm((f) => ({ ...f, [name]: value === "" ? "" : Number(value) }));
    } else {
      setForm((f) => ({ ...f, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      const payload = { ...form };
      
      await api.put(`/agent/${id}`, payload);
      navigate("/agent");
    } catch (err) {
      alert("Eroare la actualizare: " + (err.response?.data?.detail || err.message));
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return null; // sau un spinner

  return (
    <Container className="mt-4">
      <Card className="p-3">
        <h3>Editare Agent #{"{"}{id}{"}"}</h3>
        <Form onSubmit={handleSubmit}>
          <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={form.name ?? ""}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
          </Row>
          <div className="text-end">
            <Button type="submit" disabled={submitting}>Salvează</Button>
          </div>
        </Form>
      </Card>
    </Container>
  );
}
